module.exports = __webpack_public_path__ + "static/things-logo-c7dcd0e8465e66b20c74346cd65073ba.png";